import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDesistementEncaissementTable, IAuthReduxProps, ITarget } from '../../types/interfaces';
import EncaissementScanModal from '../encaissement_list/EncaissementScanModal';
import { PRIVILEGE } from '../../types/privileges'

import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faMoneyCheck, faPlus, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from "moment";
import { getFtpCheck } from '../../flux/actions/encaissementActions';
import Loading from '../Loading';
import EDTSwitchCell from '../tables_manager/EDTSwitchCell';
import { getEncModeRegl, getEncStatut } from '../../services/misc';
import { SelectColumnFilter } from '../tables_manager/filters';
import { constants } from '../../types/constants';

const DesistementEncaissementTable = ({ 
  setTableData,
  linesData,
  panelNumber,
  enableDesistement,
  enableTransfert,
  auth
 }: IDesistementEncaissementTable) => {
  const history = useHistory();
  const skipResetRef = React.useRef(false);
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');

  const columns = [
    ...(!!(/*auth?.user?.privileges?.includes(PRIVILEGE.TRANSFERT) && */!!enableTransfert) ? [{
      Header: "Transférer",
      accessor: "transfere",
      Cell: EDTSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    ...(!!(/*auth?.user?.privileges?.includes(PRIVILEGE.DESISTEMENT) && */!!enableDesistement) ? [{
      Header: "Désister",
      accessor: "desiste",
      // Cell: e => DTSwitchCell({...e, customKey: `panel${panelNumber}_encaissement`}),
      Cell: EDTSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    {
      Header: "ID Système",
      accessor: "id",
      disableFilters: true,
      Cell: ({ row: {original} }) => original.encaissement?.id || "-",
      hidden: true
    },
    {
      Header: "Tiré par",
      accessor: "TIRE_PAR",
      disableFilters: true,
      Cell: ({ row: {original} }) => original.encaissement?.TIRE_PAR || "-"
    },
    {
      Header: "Au profit de",
      accessor: "PROFIT_DE",
      disableFilters: true,
      Cell: ({ value }) => value && value != "00000000000000000" ? value : "-"
    },
    {
      Header: "Mode de règlement",
      accessor: "MODE_REGL",
      disableFilters: true,
      Cell: ({ row: {original} }) => getEncModeRegl(original.encaissement?.MODE_REGL)
    },
    {
      Header: "Type échéance",
      accessor: "TYPE_ECHEANCE",
      disableFilters: true,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Réf. Règlement",
      accessor: "REF_REGLEMENT",
      disableFilters: true,
      Cell: ({ row: {original} }) => original.encaissement?.REF_REGLEMENT || "-"
    },
    {
      Header: "Banque",
      accessor: "BANQUE",
      disableFilters: true,
      Cell: ({ row: {original} }) => original.encaissement?.BANQUE || "-"
    },
    {
      Header: "Date Encaissement",
      accessor: "DATE_REGLEMENT",
      disableFilters: true,
      customExportDisplay: `$.encaissement && $.encaissement.DATE_REGLEMENT ? new Date($.encaissement.DATE_REGLEMENT) : "-"`,
      Cell: ({ row: {original} }) => original.encaissement?.DATE_REGLEMENT ? moment(original.encaissement.DATE_REGLEMENT).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Date de CHQ/VAL",
      accessor: "DATE_PORTEFEUILLE",
      disableFilters: true,
      // sortType: (a, b, id, desc) => a.original[id]
      customExportDisplay: `$.encaissement && $.encaissement.DATE_PORTEFEUILLE ? new Date($.encaissement.DATE_PORTEFEUILLE) : "-"`,
      Cell: ({ row: {original} }) => original.encaissement?.DATE_PORTEFEUILLE ? moment(original.encaissement.DATE_PORTEFEUILLE).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Montant encaissé",
      accessor: "PART",
      disableFilters: true,
      // sortType: (a, b, id, desc) => ((a.original[id]?.PART !== null && a.original[id]?.PART !== undefined && a.original[id]?.PART != "") ? Number(a.original[id]?.PART) : 0)
      //                             > ((b.original[id]?.PART !== null && b.original[id]?.PART !== undefined && b.original[id]?.PART != "") ? Number(b.original[id]?.PART) : 0) ? 1 : -1,
      Cell: ({ row: {original} }) => original.PART === original.encaissement?.MONTANT ? ((original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-") : (<div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}&nbsp;</div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.encaissement?.MONTANT !== null && original.encaissement?.MONTANT !== undefined && original.encaissement?.MONTANT != "") ? ("(de " + original.encaissement.MONTANT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh)") : "-"}</div></div>)
    },
    // {
    //   Header: "Observation",
    //   accessor: "OBSERVATION",
    //   disableFilters: true
    // },
    {
      Header: "Banque versement",
      accessor: "BANQUE_VERSEMENT",
      disableFilters: true,
      Cell: ({ row: {original} }) => original.encaissement?.BANQUE_VERSEMENT || "-",
      hidden: true
    },
    {
      Header: "Statut",
      accessor: row => getEncStatut(row.encaissement?.STATUT),
      customExportDisplay: `$.encaissement ? getEncStatutHandle($.encaissement.STATUT) : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Aperçus",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
              {original.encaissement && (original.encaissement.recto_name ||original.encaissement.verso_name || original.encaissement.URL || original.encaissement.URL_VERSO) ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => (setModalEncaissement(original.encaissement), setModal(true))}
                title="Aperçu des Scans">
                <FontAwesomeIcon icon={faMoneyCheck} />
              </button> : null}
              {/* <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => handleDelete(row.original.lineIndex)}
                title="Supprimer">
                <FontAwesomeIcon icon={faTrash} />
              </button> */}
          </Container>
      ),
    }
  ];

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [linesData])

  return (
    <>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="encaissements" enableCheckBox={false} hideExport={true} isEditable={true} disableFilter updateMyData={updateMyData} skipPageReset={skipResetRef.current} />
      </Container>
      <EncaissementScanModal modal={modal} setModal={setModal} modalEncaissement={modalEncaissement} setModalEncaissement={setModalEncaissement} />
    </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { })(DesistementEncaissementTable);
